import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import HeadlineEnhanced from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/HeadlineEnhanced"
import React from "react"
import SbEditable from "storyblok-react"

const DonationExampleBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="donation-example-block">
        <div className="block-w-content">
          <HeadlineEnhanced
            kicker={block.kicker}
            headline={block.headline}
            subheadline={block.subheadline}
          />
          <div className="flex flex-row flex-wrap -mx-grid">
            {block.donation_example_items?.length > 0 &&
              block.donation_example_items.map((item, index) => (
                <div
                  key={`example-${index}`}
                  className="block w-full mt-8 sm:w-1/3 px-grid"
                >
                  <div className="h-full border border-gray-100 shadow-lg">
                    <div className="flex flex-col justify-between h-full">
                      <div>
                        <div>
                          <Image
                            className="w-full"
                            aspectRatio="3by2"
                            image={item.image}
                          />
                        </div>
                        <div className="p-4">
                          <div className="flex flex-row flex-wrap -mx-grid">
                            <span className="w-full text-3xl font-bold lg:text-right lg:w-2/5 px-grid lg:order-last">
                              {item.donation_amount}&nbsp;€
                            </span>
                            <span className="w-full lg:w-3/5 px-grid">
                              {item.text}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="px-4 pb-4">
                        <Link
                          className="btn btn-primary"
                          link="/hilfen/spenden-formular"
                          target="_blank"
                        >
                          {item.donation_amount} € spenden
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default DonationExampleBlock
